GatiServerGame = function () {
  GatiServer.call(this);

  this.inShuffle = false;
  this.shuffleIndex = 0;
  this.shuffleWinnings = 0;
  this.shuffleCount = 0;
  this.force = undefined;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inBuyABonus = false;
  this._inBuyABonusXtra = false;
  this._inEncore = false;
  this._babNormalCostMultiplier;
  this._babEnhancedCostMultiplier;
  this._shuffleMysterySymbol = undefined;

  this._xSymbolData = undefined;

  //this.loadLanguageFiles = undefined; // delete me when translations are ready
};

GatiServer.prototype.checkForAndHandlePrepaids = function (prepaidObj) {
  if (prepaidObj && prepaidObj.amount) {
    gameData.slotConfig.promotionActive = true;
    this.changeStake(prepaidObj.amount * 100);
    messageBus.post('prepaid:StakeChange', prepaidObj.amount * 100);
    messageBus.post('common:PromotionStarted');
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: false,
    });

    this._isPrePaidGame = true;
  } else if (this._isPrePaidGame) {
    this._isPrePaidGame = false;
    messageBus.post('common:PromotionEnded', {
      replayGame: this._inRewatchMode || this._inReplayMode,
    });
    messageBus.post('platform:setButtonState', {
      buttonName: 'Stake',
      enabled: true,
    });
  }
};

GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);
GatiServerGame.prototype.constructor = GatiServerGame;

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    'LEFT_TOP',
    ['playerState']
  );
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  if (this._inReplayMode === true && this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true) {
    this.prepaidInitialBalance = parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance = parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }

  if (loadData?.settings?.gameFeatures?.playerState?.playerState?.state) {
    const playerStateString = JSON.parse(loadData.settings.gameFeatures.playerState.playerState.state);
    const version = playerStateString?.FS?.Version;

    if (version && version < 2) {
      loadData.settings.gameFeatures.playerState.playerState = undefined;
    }
  }

  this.addGameConfigToQueueBase(loadData);

  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  this.cheatPanelActive = loadData.customParameters.cheatPanel === 'yes';

  gameData.license = loadData.customParameters.license;

  if (gameData.license === '' || gameData.license === undefined) {
    gameData.license = 'default';
  } else {
    gameData.license = gameData.license.toUpperCase();
  }

  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;

  if (configMessage.slotConfig.gameModes.BONUS_BUY) {
    // This game mode can be disabled so need to check if exists
    this._babNormalCostMultiplier = configMessage.slotConfig.gameModes.BONUS_BUY.coinsPerBet / 10;
  }
  if (configMessage.slotConfig.gameModes.BONUS_BUY_XTRA) {
    // This game mode can be disabled so need to check if exists
    this._babEnhancedCostMultiplier = configMessage.slotConfig.gameModes.BONUS_BUY_XTRA.coinsPerBet / 10;
  }

  configMessage.buyBonusCostNormal = this._babNormalCostMultiplier;
  configMessage.buyBonusCostEnhanced = this._babEnhancedCostMultiplier;

  configMessage.slotConfig.coins = 10; // purely paytable

  gameData.recoveryStake = undefined;

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === 'GOLDENBET_BUY') {
      gameData.recoveryStake *= 1.5;
      gameData.recoveryMode = 'GOLDENBET_BUY';
    } else if (betData.cmd === 'BONUS_BUY') {
      gameData.recoveryMode = 'BONUS_BUY';
    } else if (betData.cmd === 'BONUS_BUY_XTRA') {
      gameData.recoveryMode = 'BONUS_BUY_XTRA';
    }
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'GOLDENBET_BUY') {
      this._inEncore = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      persistence.setCurrentMode('GOLDENBET_BUY');
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY') {
      this._inBuyABonus = true;
      this._inBuyABonusXtra = false;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      persistence.setCurrentMode('BONUS_BUY');
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_XTRA') {
      this._inBuyABonus = true;
      this._inBuyABonusXtra = true;
      this._meta = {
        name: 'buyABonusXtra',
        value: true,
      };
      persistence.setCurrentMode('BONUS_BUY_XTRA');
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inBuyABonusXtra = stakeData.metaData.buyABonusXtra;
  this._inEncore = stakeData.metaData.encore;

  if (this._forces === undefined || !this._forces) {
    this._forces = '';
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController('stakeController');
  let baseStake = stakeController.getBaseStake('default') / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === '' && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  persistence.setCurrentMode('BASIC');

  if (this._inEncore) {
    this._coinValue = 10; // has to be whole number
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'GOLDENBET_BUY';
    persistence.setCurrentMode('GOLDENBET_BUY');
  } else if (this._inBuyABonusXtra) {
    baseStake = stakeController.getBaseStake('BONUS_BUY_XTRA') / 100;
    request.amount = baseStake * this._babEnhancedCostMultiplier;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'BONUS_BUY_XTRA';
    persistence.setCurrentMode('BONUS_BUY_XTRA');
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake('BONUS_BUY') / 100;
    request.amount = baseStake * this._babNormalCostMultiplier;
    request.coin = baseStake / this._coinValue;
    request.cmd = 'BONUS_BUY';
    persistence.setCurrentMode('BONUS_BUY');
  }
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController('stakeController');
    if (sc.isMaxStake() && !this._inReplayMode && !this._inRewatchMode && !this._isPrePaidGame && !isStakeLower) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  // this doesn't set the correct stake in recovery - but shouldn't affect anything...
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.addXtraPowerIntroToQueue = function (trail, startingXs, sphereBoosts) {
  this.shuffleCount = 0;
  let message = {};
  message.type = 'spinner:XtraPowerIntroEvent';
  message.trail = trail;
  message.startingXs = startingXs;
  message.sphereBoosts = sphereBoosts;
  this.shuffleWinnings = 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addShuffleIntroToQueue = function (trail, startingXs, xtraPowerFeature) {
  this.shuffleCount = 0;
  let message = {};
  message.type = 'spinner:ShuffleIntroEvent';
  message.trail = trail;
  message.startingXs = startingXs;
  message.xtraPowerFeature = xtraPowerFeature;
  this.shuffleWinnings = 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addShuffleStartToQueue = function (trail, startingXs, xtraPowerFeature) {
  this.shuffleCount = 0;
  let message = {};
  message.type = 'spinner:ShuffleStartEvent';
  message.trail = trail;
  message.startingXs = startingXs;
  message.xtraPowerFeature = xtraPowerFeature;
  this.shuffleWinnings = 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addWildAddedDataToQueue = function (coord) {
  let message = {};
  message.type = 'sidewinder:WildAddedEvent';
  message.coord = coord;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addSuperWildAddedDataToQueue = function (coord) {
  let message = {};
  message.type = 'sidewinder:SuperWildAddedEvent';
  message.coord = coord;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addMegaWildAddedDataToQueue = function (coord) {
  let message = {};
  message.type = 'sidewinder:MegaWildAddedEvent';
  message.coord = coord;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addBoostDataToQueue = function (boostData) {
  let message = {};
  message.type = 'sidewinder:BoostAddedEvent';
  message.boostData = boostData;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addMysterySymbolDataToQueue = function (mysteryData, totalLineWinnings) {
  let message = {};
  message.type = 'sidewinder:MysteryDataEvent';
  message.mysteryData = mysteryData;
  message.totalLineWinnings = totalLineWinnings || 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addXSymbolDataToQueue = function (xSymbolData) {
  let message = {};
  message.type = 'sidewinder:XSymbolDataEvent';
  message.xSymbolData = xSymbolData;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addPowerBarAdjustToQueue = function (xPowerBarData, powerSpheres) {
  let message = {};
  message.type = 'sidewinder:PowerBarAdjustEvent';
  message.xPowerBar = xPowerBarData;
  message.powerSpheres = powerSpheres;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addXtraPowerTriggerToQueue = function () {
  let message = {};
  message.type = 'sidewinder:XtraPowerTriggerEvent';
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addXtraPowerBonusBuyStartToQueue = function () {
  let message = {};
  message.type = 'sidewinder:XtraPowerBonusBuyStart';
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addShuffleDataToQueue = function (
  startReelList,
  endReelList,
  lastShuffle,
  shuttersData,
  previousShutterPositions,
  perm,
  multiplier,
  winAmount
) {
  let message = {};
  message.type = 'spinner:ShuffleDataEvent';
  message.startReelList = startReelList;
  message.endReelList = endReelList;
  message.lastShuffle = lastShuffle;
  message.shuffleWinnings = this.shuffleWinnings;
  message.shuttersData = shuttersData || null;
  message.previousShutterPositions = previousShutterPositions || null;
  message.perm = perm || null;
  message.multiplier = multiplier;
  message.winAmount = winAmount || 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addShuffleEndToQueue = function (winnings) {
  let message = {};
  message.type = 'spinner:ShuffleEndEvent';
  message.shuffleWinnings = winnings;
  this.shuffleWinnings = 0;
  this.inShuffle = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data, playerState, initialPlayerState) {
  if (this.inShuffle) {
    this.getSpinDataShuffle(cb);
  } else {
    persistence.apply(playerState);

    let parts = data.Parts;

    let totalWon = 0;
    for (let i = 0; i < parts.length; ++i) {
      let type = parts[i].type;
      this._forces = '';
      if (type === 'baseGame') {
        totalWon += this.getSpinDataNormal(parts[i]);
        // base game only, game complete
        if (parts.length === 1) {
          this.addGameCompleteToQueue(totalWon);
        }
      } else if (type === 'shuffleGame') {
        this.inShuffle = true;
        this.shuffleCount = 0;
        this.shuffles = parts[i].shuffle.shuffles;
        totalWon += this.getSpinDataShuffleInit(parts[i]);
      }
    }
    cb();
    this.triggerNextMessage();
  }
};

GatiServerGame.prototype.addAllWinsToQueue = function (spin, isCapped, cappedWin) {
  let winningLinesEvent = spin.winningLinesEvent;
  let rightToLeftWinningLinesEvent = spin.rightToLeftWinningLineEvent;

  if (!this.validateResponse(winningLinesEvent)) return;
  if (!this.validateResponse(rightToLeftWinningLinesEvent)) return;

  let allWinsLines = [];
  winningLinesEvent.winningLines.forEach(function (win) {
    win.direction = 1;
    allWinsLines.push(win);
  });
  rightToLeftWinningLinesEvent.winningLines.forEach(function (win) {
    win.direction = -1;
    allWinsLines.push(win);
  });
  const allWins = {
    totalLineWinnings: winningLinesEvent.totalLineWinnings + rightToLeftWinningLinesEvent.totalLineWinnings,
    winningLines: allWinsLines,
  };

  if (allWins.totalLineWinnings > 0 && allWins.winningLines.length > 0) {
    this.addWinningsToQueue(allWins);
    let winCapped = false;
    if (isCapped !== undefined) {
      winCapped = isCapped;
    }
    const payWinsMessage = this._messageQueue[this._messageQueue.length - 1];
    payWinsMessage.isCapped = winCapped;
    if (winCapped) {
      payWinsMessage.totalLineWinnings = cappedWin;
    }
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  let spinEvent = data.baseSpin.spin.spinEvent;

  if (!this.validateResponse(spinEvent)) return;

  if (data.modifier !== undefined && data.modifier.isAwarded) {
    let cloneFake = JSON.parse(JSON.stringify(data.modifier.resultsPanel.reelList));
    spinEvent.resultsPanel.reelList = cloneFake;
  }
  this.addSpinDataToQueue(spinEvent, data);

  this.addAllWinsToQueue(data.baseSpin.spin);

  return spinEvent.totalWinnings;
};

GatiServerGame.prototype.getSpinDataShuffleInit = function (data) {
  let spinEvent = data.shuffle.initialSpins[0].spinEvent;

  if (!this.validateResponse(spinEvent)) return;
  this.addSpinDataToQueue(spinEvent, data);

  this.addAllWinsToQueue(data.shuffle.initialSpins[0]);

  const startingXs = data.shuffle.xsUsed;
  const sphereBoosts = data.shuffle.sphereBoosts;
  const xtraPowerFeature = data.wasXtraPowerGame;

  ///////////////////////////////////////////////////////
  // Fix broken trail
  let changed = true;

  while (changed) {
    changed = false;

    for (let i = 1; i < data.trail.length; i++) {
      if (data.trail[i].multiplier < data.trail[i - 1].multiplier) {
        data.trail.splice(0, i);
        changed = true;
        break;
      }
    }
  }
  //////////////////////////////////////////////////////

  this.addShuffleIntroToQueue(data.trail, startingXs, xtraPowerFeature);
  if (xtraPowerFeature) {
    this.addXtraPowerIntroToQueue(data.trail, startingXs, sphereBoosts);
  }
  this.addShuffleStartToQueue(data.trail, startingXs, xtraPowerFeature);

  this._previousStartReelList = spinEvent.resultsPanel.reelList;

  return spinEvent.totalWinnings;
};

GatiServerGame.prototype.getSpinDataShuffle = function (cb) {
  let thisShuffleOutcome = this.shuffles[this.shuffleCount++];

  let spinEvent = thisShuffleOutcome.spin.spinEvent;
  let reelList = spinEvent.resultsPanel.reelList;

  const symbolsInfo = resourceManager.getConfiguration().symbols;

  const currentShutterSymbol =
    thisShuffleOutcome.spin.shutters && thisShuffleOutcome.spin.shutters.symbol !== null
      ? thisShuffleOutcome.spin.shutters.symbol
      : this._shuffleMysterySymbol;

  if (currentShutterSymbol !== undefined) {
    for (let reel = 0; reel < reelList.length; reel++) {
      for (let row = 0; row < reelList[reel].symbols.length; row++) {
        if (reelList[reel].symbols[row].value === symbolsInfo['Mystery'].ID) {
          reelList[reel].symbols[row].value = currentShutterSymbol;
        }
      }
    }
  }

  const award = thisShuffleOutcome.awardAdded;

  if (award === 'Wild') {
    const wildCoord = {
      reel: thisShuffleOutcome.awardAddedCoord.reel,
      row: thisShuffleOutcome.awardAddedCoord.row,
      symId: symbolsInfo['Wild'].ID,
    };
    this.addWildAddedDataToQueue(wildCoord);
    this._previousStartReelList[wildCoord.reel].symbols[wildCoord.row].value = symbolsInfo['Wild'].ID;
  }
  if (award === 'SuperWild') {
    const superwildCoord = {
      reel: thisShuffleOutcome.awardAddedCoord.reel,
      symId: symbolsInfo['SuperWild'].ID,
    };
    this.addSuperWildAddedDataToQueue(superwildCoord);
    for (let row = 0; row < this._previousStartReelList[superwildCoord.reel].symbols.length; ++row) {
      this._previousStartReelList[superwildCoord.reel].symbols[row].value = symbolsInfo['SuperWild'].ID;
    }
  }
  if (award === 'MegaWild_X2' || award === 'MegaWild_X3' || award === 'MegaWild_X5') {
    let multiplier = 0;
    if (award === 'MegaWild_X3') {
      multiplier = 3;
    } else if (award === 'MegaWild_X5') {
      multiplier = 5;
    } else {
      multiplier = 2;
    }
    const megawildCoord = {
      reel: thisShuffleOutcome.awardAddedCoord.reel,
      symId: symbolsInfo[award].ID,
      multiplier: multiplier,
    };
    this.addMegaWildAddedDataToQueue(megawildCoord);
    for (let row = 0; row < this._previousStartReelList[megawildCoord.reel].symbols.length; ++row) {
      this._previousStartReelList[megawildCoord.reel].symbols[row].value = symbolsInfo[award].ID;
    }
  }
  if (award === 'Boost') {
    let boostData = {
      oldSym: thisShuffleOutcome.spin.boost.originalSymbol,
      newSym: thisShuffleOutcome.spin.boost.replacedSymbol,
      coords: [],
    };
    for (let reel = 0; reel < this._previousStartReelList.length; reel++) {
      for (let row = 0; row < this._previousStartReelList[reel].symbols.length; row++) {
        if (this._previousStartReelList[reel].symbols[row].value === boostData.oldSym) {
          const coord = {
            reel: reel,
            row: row,
          };
          boostData.coords.push(coord);
          this._previousStartReelList[reel].symbols[row].value = boostData.newSym;
        }
      }
    }
    this.addBoostDataToQueue(boostData);
  }
  // Jamie - temp
  // for (let i = 0; i < spinEvent.resultsPanel.reelList.length; i++) {
  //   let index = thisShuffleOutcome.perm[i];

  //   let row = [];
  //   for (let j = 0; j < 3; j++) {
  //     row.push(spinEvent.resultsPanel.reelList[index].symbols[j].value);
  //   }
  //   console.log('Row: ' + i + ' --- ' + row.join(', '));
  // }

  // Extract shutter data for this shuffle
  let shuttersData = null;
  const previousPositions = this._previousShutterPositions || null;

  if (thisShuffleOutcome.spin.shutters && thisShuffleOutcome.spin.shutters.symbol !== null) {
    shuttersData = thisShuffleOutcome.spin.shutters;
  }

  this.addShuffleDataToQueue(
    this._previousStartReelList,
    spinEvent.resultsPanel.reelList,
    this.shuffleCount >= this.shuffles.length,
    shuttersData,
    previousPositions,
    thisShuffleOutcome.perm,
    thisShuffleOutcome.multiplier,
    thisShuffleOutcome.winAmount
  );

  // Update previous positions for next shuffle
  if (shuttersData && shuttersData.positions) {
    this._previousShutterPositions = shuttersData.positions;
  }

  this._previousStartReelList = spinEvent.resultsPanel.reelList;

  this.shuffleWinnings += thisShuffleOutcome.winAmount;

  this.addAllWinsToQueue(thisShuffleOutcome.spin, thisShuffleOutcome.winCapped, thisShuffleOutcome.winAmount);

  if (this.shuffleCount >= this.shuffles.length) {
    this.addShuffleEndToQueue(this.shuffleWinnings);
    this.addGameCompleteToQueue(this.shuffleWinnings);
    this.inShuffle = false;
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.getCheatString = function () {
  return this.force;
};

GatiServerGame.prototype.logCheatString = function () {
  this.force = this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== '') {
    console.log('force: ' + this.force);
  }
};

GatiServerGame.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
};

GatiServerGame.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServerGame.prototype.addSpinDataToQueue = function (event, data) {
  var message = {};
  message.type = 'spinner:SpinEvent';

  message.panelMultiplier = 1;
  message.lines = event.lines;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  message.isPrePaidGame = this._isPrePaidGame;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = event.resultsPanel.symbolsAbove;
  message.resultPanel.symbolsBelow = event.resultsPanel.symbolsBelow;

  this._xSymbolData = undefined;

  if (this._inBuyABonusXtra && data.wasXtraPowerGame) {
    this.addPowerBarAdjustToQueue(data.xPowerBar, data.powerSpheres);
    this.addXtraPowerTriggerToQueue();
    this.addXtraPowerBonusBuyStartToQueue();
  }

  if (data.baseSpin) {
    if (data.baseSpin.xSymbolCoord) {
      const xReel = data.baseSpin.xSymbolCoord.reel;
      const xRow = data.baseSpin.xSymbolCoord.row;

      const symbolsInfo = resourceManager.getConfiguration().symbols;
      const oldSym = message.resultPanel.reelList[xReel].symbols[xRow].value;

      if (oldSym === symbolsInfo['Cherry'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Cherry_X'].ID;
      } else if (oldSym === symbolsInfo['Orange'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Orange_X'].ID;
      } else if (oldSym === symbolsInfo['Grape'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Grape_X'].ID;
      } else if (oldSym === symbolsInfo['Plum'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Plum_X'].ID;
      } else if (oldSym === symbolsInfo['SevenGreen'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['SevenGreen_X'].ID;
      } else if (oldSym === symbolsInfo['SevenRed'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['SevenRed_X'].ID;
      } else if (oldSym === symbolsInfo['SevenGold'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['SevenGold_X'].ID;
      } else if (oldSym === symbolsInfo['Logo'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Logo_X'].ID;
      } else if (oldSym === symbolsInfo['Mystery'].ID) {
        message.resultPanel.reelList[xReel].symbols[xRow].value = symbolsInfo['Mystery'].ID;
      } else {
        throw new Error("Invalid 'X' Symbol - Symbol ID: " + oldSym);
      }

      this._xSymbolData = {
        reel: xReel,
        row: xRow,
        oldSym: oldSym,
      };
    }
  }

  this._messageQueue.push(message);
  this.addAdditionalSpinData(message, data);
};

GatiServerGame.prototype.addAdditionalSpinData = function (message, data) {
  message.powerSpheres = data.powerSpheres;
  message.trail = data.trail;
  message.xPowerBar = data.xPowerBar;

  this._shuffleMysterySymbol = undefined;

  if (this._xSymbolData !== undefined) {
    this.addXSymbolDataToQueue(this._xSymbolData);
  }

  if (data.baseSpin) {
    if (data.baseSpin.spin.shutters.symbol !== null) {
      const totalWinnings =
        data.baseSpin.spin.winningLinesEvent.totalLineWinnings +
        data.baseSpin.spin.rightToLeftWinningLineEvent.totalLineWinnings;
      this.addMysterySymbolDataToQueue(data.baseSpin.spin.shutters, totalWinnings);
    }
  } else if (data.shuffle.initialSpins.length) {
    const spin = data.shuffle.initialSpins[0];
    if (spin.shutters.symbol !== null) {
      this._shuffleMysterySymbol = spin.shutters.symbol;
      this._previousShutterPositions = spin.shutters.positions;
      const totalWinnings =
        spin.winningLinesEvent.totalLineWinnings + spin.rightToLeftWinningLineEvent.totalLineWinnings;
      this.addMysterySymbolDataToQueue(spin.shutters, totalWinnings);
    }
  }

  if (data.baseSpin) {
    if (data.xPowerBar.initialBarPower !== data.xPowerBar.finalBarPower) {
      this.addPowerBarAdjustToQueue(data.xPowerBar, data.powerSpheres);

      if (data.xPowerBar.finalBarPower === data.xPowerBar.maxPower) {
        this.addXtraPowerTriggerToQueue();
      }
    }
  }
};

GatiServerGame.prototype.buildPersistenceInitialisationData = function (loadData, gameConfigMessage) {
  const initData = GatiServer.prototype.buildPersistenceInitialisationData.call(this, loadData, gameConfigMessage);

  initData.enabled = true;
  initData.dataPath = 'F.F';
  initData.modeMapping = $.extend(true, {}, initData.modeMapping, {
    BonusBuy: 'BONUS_BUY',
    BonusBuyXtra: 'BONUS_BUY_XTRA',
    GoldenBet: 'GOLDENBET_BUY',
  });
  initData.lastStakeMapping = $.extend(true, {}, initData.lastStakeMapping, {
    LASTMODE: 'M',
    LASTSTAKE: 'S',
  });
  initData.modeStakeMultipliers = $.extend(true, {}, initData.modeStakeMultipliers, {
    BASIC: 1,
    BONUS_BUY: 1,
    BONUS_BUY_XTRA: 1,
    GOLDENBET_BUY: 1.5,
  });

  initData.stakeCorrection = {
    BONUS_BUY: (stake) => {
      return (stake /= 50);
    },
    BONUS_BUY_XTRA: (stake) => {
      return (stake /= 100);
    },
    GOLDENBET_BUY: (stake) => {
      // return (stake /= 1.5);
      return stake;
    },
  };

  return initData;
};

GatiServerGame.prototype.restorePreviousGameModeData = function () {
  const _latestEngineReponse = { wager: this._previousWagers.data[0] };
  for (let i = 0; i < _latestEngineReponse.wager.bets.length; ++i) {
    let bet = _latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === 'GOLDENBET_BUY') {
      this._inEncore = true;
      this._meta = {
        name: 'encore',
        value: true,
      };
      persistence.setCurrentMode('GOLDENBET_BUY');
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY') {
      this._inBuyABonus = true;
      this._inBuyABonusXtra = false;
      this._meta = {
        name: 'buyABonus',
        value: true,
      };
      persistence.setCurrentMode('BONUS_BUY');
      break;
    } else if (bet.betdata.cmd === 'BONUS_BUY_XTRA') {
      this._inBuyABonus = true;
      this._inBuyABonusXtra = true;
      this._meta = {
        name: 'buyABonusXtra',
        value: true,
      };
      persistence.setCurrentMode('BONUS_BUY_XTRA');
      break;
    }
  }
  GatiServer.prototype.restorePreviousGameModeData.call(this);
};

GatiServerGame.prototype.isGameModeBonusBuy = function (mode) {
  return mode === 'BONUS_BUY' || mode === 'BONUS_BUY_XTRA';
};
